/**
 * Create a display array with fixed number of slots
 * Fills empty slots with null for rendering empty rows
 * 
 * @param {Array} dataArray - The source data array
 * @param {number} totalSlots - Total number of slots to create
 * @returns {Array} Array with totalSlots elements, filling gaps with null
 */
export const createDisplayArray = (dataArray, totalSlots) => {
  return Array.from({ length: totalSlots }, (_, index) => dataArray[index] || null);
};

/**
 * Get status badge CSS classes based on certificate status
 * 
 * @param {string} status - Certificate status (valid, warning, expiring, expired)
 * @returns {string} CSS class string for badge styling
 */
export const getStatusBadgeClass = (status) => {
  const statusClasses = {
    valid: 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30',
    warning: 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30',
    expiring: 'bg-orange-500/20 text-orange-400 border border-orange-500/30',
    expired: 'bg-red-500/20 text-red-400 border border-red-500/30'
  };
  return statusClasses[status] || statusClasses.expired;
};

/**
 * Get human-readable status label
 * 
 * @param {string} status - Certificate status
 * @returns {string} Display label for status
 */
export const getStatusLabel = (status) => {
  const statusLabels = {
    valid: 'Valid',
    warning: 'Warning',
    expiring: 'Expiring Soon',
    expired: 'Expired'
  };
  return statusLabels[status] || 'Unknown';
};

/**
 * Get CSS class for days left display based on value
 * 
 * @param {number} daysLeft - Number of days until expiry
 * @returns {string} CSS class for text color
 */
export const getDaysLeftClass = (daysLeft) => {
  if (daysLeft >= 30) return 'text-emerald-400';
  if (daysLeft >= 7) return 'text-yellow-400';
  return 'text-red-400';
};
